/* eslint-disable no-extra-parens */

import {
    DocumentTextIcon,
    HeroChartBarSquareIcon,
    HeroEllipsisVerticalIcon,
    NinchatTranscriptSearchIcon,
} from 'components/Icon'

import {
    Dropdown, DropdownButtonNew, DropdownContent,
} from 'components/Dropdown'

import {
    dropdownsButtonsWrapper, list,
} from '../styles'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import React from 'react'
import {RouteParams} from 'navigation/types'
import Tooltip from 'components/Tooltip'

import {navigation} from 'navigation'
import permissionGuard from 'components/Navigation/helpers/PermissionGuard'
import {styled} from 'stitches/config'

import {
    useAppSelector,
} from 'hooks'
import {useTranslation} from 'react-i18next'

const StyledList = styled('ul', list)
const StyledDropdownButtonsWrapper = styled('div', dropdownsButtonsWrapper)

export const SideMenuQueueStatisticsView = (props: {routeParams: RouteParams}): React.ReactElement => {
    const {routeParams} = props
    const {t} = useTranslation()

    const {queue_id} = useAppSelector(({navigation: navigationState}) => navigation.route.params<'QueueSettings'>(navigationState.routes[navigationState.position]))

    const hasViewRealmTranscriptPermissions = permissionGuard.hasViewRealmTranscriptPermissions()
    const hasViewRealmMetadataPermissions = permissionGuard.hasViewRealmMetadataPermissions()

    return (
        <StyledList>
            <li>
                <Dropdown>
                    <DropdownButtonNew caret={false} color='text' iconRight={HeroEllipsisVerticalIcon as unknown as Icon} />
                    <DropdownContent direction='left' >
                        <StyledDropdownButtonsWrapper>
                            <Button
                                color='text'
                                iconLeft={HeroChartBarSquareIcon as unknown as Icon}
                                onPress={(): void => {
                                    navigation.push('QueueStatistics', {
                                        ...routeParams,
                                        queue_id,
                                        tab: 'default',
                                    })
                                }}
                                text={t('Queue statistics')}
                            />
                            {hasViewRealmTranscriptPermissions ?
                                <Button
                                    color='text'
                                    iconLeft={NinchatTranscriptSearchIcon as unknown as Icon}
                                    onPress={(): void => {
                                        navigation.push('QueueStatistics', {
                                            ...routeParams,
                                            queue_id,
                                            tab: 'transcript',

                                        })
                                    }}
                                    text={t('Transcripts')}
                                />
                                : null}
                            {hasViewRealmMetadataPermissions ?
                                <Button
                                    color='text'
                                    iconLeft={DocumentTextIcon as unknown as Icon}
                                    onPress={(): void => {
                                        navigation.push('QueueStatistics', {
                                            ...routeParams,
                                            queue_id,
                                            tab: 'metadata',

                                        })
                                    }}
                                    text={t('Metadata & questionnaire answers')}
                                />
                                : null}
                        </StyledDropdownButtonsWrapper>
                    </DropdownContent>
                </Dropdown>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='statistics'
                    iconLeft={HeroChartBarSquareIcon as unknown as Icon}
                    onPress={(): void => {
                        navigation.push('QueueStatistics', {
                            ...routeParams,
                            tab: 'default',
                        })
                    }}
                    text=''
                />
                <Tooltip id='statistics' position='right' singleLine>
                    {t('Queue statistics')}
                </Tooltip>
            </li>
            {hasViewRealmTranscriptPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='transcripts'
                        iconLeft={NinchatTranscriptSearchIcon as unknown as Icon}
                        onPress={(): void => {
                            navigation.push('QueueStatistics', {
                                ...routeParams,
                                tab: 'transcript',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='transcripts' position='right' singleLine>
                        {t('Transcripts')}
                    </Tooltip>
                </li>
                : null}
            {hasViewRealmMetadataPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='metadata'
                        iconLeft={DocumentTextIcon as unknown as Icon}
                        onPress={(): void => {
                            navigation.push('QueueStatistics', {
                                ...routeParams,
                                tab: 'metadata',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='metadata' position='right' singleLine>
                        {t('Metadata & questionnaire answers')}
                    </Tooltip>
                </li>
                : null}
        </StyledList>
    )
}
